import React, {PureComponent} from 'react';

type PropTypes = {};

export default class EmptyComponent extends PureComponent {
  props: PropTypes;

  render = () => <span />;
}
